app.service('loginView', function (modal, pageConfig, message){
	var config = false;

	function init(){
		config = pageConfig.getData('order');

		if (config.nklSessionExpired) {
			message.get('nkl-session-expired-message').then(function (html) {
				modal.generate({
					id: 'nkl-error',
					content: html
				});
			});
		}
	}
	return {
		init
	};
});
